import _toConsumableArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import useSWRImmutable from 'swr/immutable';
export var toUseStartClass = function toUseStartClass(PelotonFetchers, WorkoutFetchers) {
  return function (params) {
    var _peloton$data, _workout$error, _workout$error$respon, _workout$error$respon2, _peloton$error, _peloton$error$respon, _peloton$error$respon2;

    var args = PelotonFetchers.CreatePeloton({
      rideId: params.rideId
    });
    var peloton = useSWRImmutable.apply(void 0, _toConsumableArray(args));
    var workout = useSWRImmutable.apply(void 0, _toConsumableArray(WorkoutFetchers.CreateWorkout({
      pelotonId: (_peloton$data = peloton.data) === null || _peloton$data === void 0 ? void 0 : _peloton$data.id,
      streamSubscriptionId: params.streamSubscriptionId,
      streamSubscriptionIdType: params.streamSubscriptionIdType,
      workoutType: 'class',
      analyticsProps: params.analyticsProps
    })));
    return {
      data: {
        peloton: peloton.data,
        workout: workout.data
      },
      errors: [workout === null || workout === void 0 ? void 0 : (_workout$error = workout.error) === null || _workout$error === void 0 ? void 0 : (_workout$error$respon = _workout$error.response) === null || _workout$error$respon === void 0 ? void 0 : (_workout$error$respon2 = _workout$error$respon.data) === null || _workout$error$respon2 === void 0 ? void 0 : _workout$error$respon2.errorCode, peloton === null || peloton === void 0 ? void 0 : (_peloton$error = peloton.error) === null || _peloton$error === void 0 ? void 0 : (_peloton$error$respon = _peloton$error.response) === null || _peloton$error$respon === void 0 ? void 0 : (_peloton$error$respon2 = _peloton$error$respon.data) === null || _peloton$error$respon2 === void 0 ? void 0 : _peloton$error$respon2.errorCode],
      isValidating: peloton.isValidating || workout.isValidating
    };
  };
};